import { useCallback, useEffect } from "react";

export const useKeyboardHandling = (
  textareaRef,
  message,
  handleMentionKeyDown,
  filteredItems,
  handleItemMentionSelect,
  handleSubmit,
  forceTriggerMentionDropdown
) => {
  // Handle keyboard events for mention dropdown and message sending
  const handleKeyDown = useCallback(
    (e) => {
      // Handle keyboard navigation for file/memory selection
      const mentionHandled = handleMentionKeyDown(
        e,
        filteredItems,
        handleItemMentionSelect
      );
      if (mentionHandled) return;

      // Regular message sending with Enter
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        handleSubmit(e);
      }
    },
    [handleSubmit, handleMentionKeyDown, filteredItems, handleItemMentionSelect]
  );

  // Create a direct way to detect @ symbol - improved version
  useEffect(() => {
    // Direct event listener for @ key detection
    const directKeyHandler = (e) => {
      if (e.key === "@") {
        e.preventDefault(); // Prevent default @ insertion

        // Insert @ manually
        const textarea = textareaRef.current;
        if (textarea) {
          const start = textarea.selectionStart;
          const end = textarea.selectionEnd;
          const newText =
            message.substring(0, start) + "@" + message.substring(end);

          // Set cursor position after the @
          setTimeout(() => {
            textarea.selectionStart = start + 1;
            textarea.selectionEnd = start + 1;

            // Force trigger the dropdown
            forceTriggerMentionDropdown();
          }, 10);
        }
      }
    };

    // Add direct listener to textarea
    const textareaElement = textareaRef.current;
    if (textareaElement) {
      textareaElement.addEventListener("keydown", directKeyHandler);
      return () => {
        textareaElement.removeEventListener("keydown", directKeyHandler);
      };
    }
  }, [message, textareaRef, forceTriggerMentionDropdown]);

  return {
    handleKeyDown,
  };
};
